import React, { useContext, useEffect, useState } from "react"
import { Row, Col } from "react-bootstrap"
import PictureCaption from "./picture-caption"

import {
  CART_FETCH,
  SHORTLIST_FETCH,
  STATISTICS_FETCH,
} from "../company-profile/statistics/action/statisticsAction"

import TimelineInfo from "./timeline-info"
import TimelineExperienceInfo from "./timeline-info-experience"
import { getCurrentAge } from "../../utils/format-date-time"
import ModalComponent from "../modal/modal"
import renderElement from "../../utils/renderElement"
import { GlobalAuthContext } from "../../context/authContext"
import SocialIcons from "../social-icons"
import { formatSalaryWithComma } from "../../utils/formatSalary"
import { GET_CONFIG_DATA } from "../shared-actions/get-config-data"
import NameSection from "./name-section"

const InfoSection = ({ profile, loading, layoutType }) => {
  const [show, setShow] = useState(false)
  const [show_train, setShow_train] = useState(false)
  const [cart, setCart] = useState(false) // eslint-disable-line no-unused-vars
  const [shortlist, setShortlist] = useState(false) // eslint-disable-line no-unused-vars
  const [stats, setStats] = useState({}) // eslint-disable-line no-unused-vars
  const [selectedPortfolio, setSelectedPortfolio] = useState({
    image: "",
    title: "",
    project_url: "",
    description: "",
  })
  const [selectedCertificate, setSelectedCertificate] = useState({
    image: "",
    title: "",
    // url: "",
    description: "",
  })

  const handlePortfolioClose = () => {
    if (!loading) {
      setShow(false)
    }
  }

  const handleTrainingClose = () => {
    if (!loading) {
      setShow_train(false)
    }
  }

  const showTraining = (value, certificate) => {
    setSelectedCertificate(certificate)
    setShow_train(value)
  }

  const showPortfolio = (value, portfolio) => {
    setSelectedPortfolio(portfolio)
    setShow(value)
  }

  const getNumberOfEmployees = (number_list, value) => {
    const fvalue = number_list?.filter(
      num_list_value => num_list_value?.id?.toString() === value?.toString()
    )
    return fvalue?.[0]?.display
  }

  const { state, dispatch } = useContext(GlobalAuthContext)

  const showContactInfo = () => {
    if (!profile?.contact) return false
    if (!state?.isAuthenticated) return false
    if (profile?.contact && state?.user?.id === profile?.id) return true
    if (state?.user?.role === 3 && profile?.contact) return true
    if (state?.user?.role === 2 && profile?.profile?.role === "company")
      return false
  }

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))
      const username = user.username
      if (state?.user?.company?.id) {
        CART_FETCH(dispatch, setCart)
        SHORTLIST_FETCH(dispatch, setShortlist, user.company.id)
      }
      STATISTICS_FETCH(setStats, () => {}, username)
      GET_CONFIG_DATA(() => {}, dispatch)
    } catch (error) {}
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Col lg={"8"}>
        <div className="info-section">
          <Row>
            <Col lg="8 order-12 order-lg-1">
              <>
                <div className="mb-4 pb-4 border-bottom name-container">
                  <NameSection
                    profile={
                      profile?.role === "candidate"
                        ? profile
                        : { ...profile?.profile, contact: profile?.contact }
                    }
                  />
                </div>
              </>
              <>
                {profile?.candidate?.id ? (
                  <>
                    <Row className="mb-3">
                      {((!showContactInfo() && state?.user?.role === 3) ||
                        !state?.isAuthenticated) && (
                        <Col lg="12">
                          <div className="blue-text pt-2 pb-2 mb-4">
                            <p className="contact-info mb-0">
                              Contact information will be revealed once you pay
                              for CV.
                            </p>
                          </div>
                        </Col>
                      )}
                      <Col xs="12" md="5">
                        Status
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.profile.status}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Experience
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.profile.experience}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Expected Salary
                      </Col>
                      <Col xs="12" md="7">
                        <strong>
                          {formatSalaryWithComma(profile.profile.salary)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Industry
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.profile.industry}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Work Type(Preferred)
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.candidate.job_type}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Work Time(Preferred)
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.candidate.job_shift}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Gender
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{profile.candidate.gender}</strong>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Age
                      </Col>
                      <Col xs="12" md="7">
                        <strong>{getCurrentAge(profile.candidate.dob)}</strong>
                      </Col>
                    </Row>
                    {showContactInfo() && (
                      <>
                        <Row className="mb-3">
                          <Col xs="12" md="5">
                            Email
                          </Col>
                          <Col xs="12" md="7">
                            <strong className="blue-text">
                              <a href={`mailto:${profile.email}`}>
                                {profile.email}
                              </a>
                            </strong>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs="12" md="5">
                            Phone
                          </Col>
                          <Col xs="12" md="7">
                            <strong className="blue-text">
                              <a href={`tel:${profile.contact}`}>
                                {profile.contact}
                              </a>
                            </strong>
                          </Col>
                        </Row>
                        {profile?.website !== "-" && profile?.website !== "" && (
                          <Row className="mb-3">
                            <Col xs="12" md="5">
                              Website
                            </Col>
                            <Col xs="12" md="7">
                              <strong className="blue-text">
                                <a
                                  href={profile.website}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {profile.website}
                                </a>
                              </strong>
                            </Col>
                          </Row>
                        )}
                        {!!profile?.social && (
                          <Row className="mb-3">
                            <Col xs="12" md="5">
                              <strong>Social</strong>
                            </Col>
                            <Col md="12" className="mt-2">
                              <SocialIcons
                                contact={JSON.parse(profile?.social)}
                              />
                            </Col>
                          </Row>
                        )}
                      </>
                    )}

                    <Row>
                      <Col md="12">
                        <strong>Skills</strong>
                      </Col>
                      <Col>
                        <ul className="skills">
                          {profile.skills.length > 0 &&
                          !!profile.skills[0] &&
                          profile.skills[0].skill.length > 0 ? (
                            profile.skills[0].skill.map(skill => {
                              if (skill !== "") {
                                return (
                                  <li key={skill}>
                                    <span>{skill}</span>
                                  </li>
                                )
                              } else {
                                return <li>No skills to show.</li>
                              }
                            })
                          ) : (
                            <li>No skills to show.</li>
                          )}
                        </ul>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Year Of Establishment
                      </Col>
                      <Col xs="12" md="7">
                        <strong>
                          {profile?.profile?.year_of_establishment ||
                            profile?.year_of_establishment}
                        </strong>
                      </Col>
                    </Row>
                    {state?.config?.number_of_employees && (
                      <Row className="mb-3">
                        <Col xs="12" md="5">
                          No. Of Employees
                        </Col>
                        <Col xs="12" md="7">
                          <strong>
                            {getNumberOfEmployees(
                              state?.config?.number_of_employees,
                              profile?.profile?.num_of_employees
                            )}
                          </strong>
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Col xs="12" md="5">
                        Industry
                      </Col>
                      <Col xs="12" md="7">
                        <strong>
                          {profile?.profile?.industry_name ||
                            profile?.industry_name}
                        </strong>
                      </Col>
                    </Row>
                    {showContactInfo() && (
                      <>
                        <Row className="mb-3">
                          <Col xs="12" md="5">
                            Email
                          </Col>
                          <Col xs="12" md="7">
                            <strong className="blue-text">
                              {profile?.contact?.email ? (
                                <a
                                  href={"mailto:" + profile.contact.email}
                                  rel="noreferrer"
                                >
                                  {profile.contact.email}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </strong>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs="12" md="5">
                            Phone
                          </Col>
                          <Col xs="12" md="7">
                            <strong className="blue-text">
                              {profile?.contact?.phonenumber ? (
                                <a
                                  href={"tel:" + profile.contact.phonenumber}
                                  rel="noreferrer"
                                >
                                  {profile.contact.phonenumber}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </strong>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs="12" md="5">
                            Website
                          </Col>
                          <Col xs="12" md="7">
                            <strong className="blue-text">
                              {profile?.contact?.website ? (
                                <a
                                  href={profile.contact.website}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {profile.contact.website}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </strong>
                          </Col>
                        </Row>
                        {profile?.contact?.social && (
                          <Row className="mb-3">
                            <Col xs="12" md="5">
                              Social
                            </Col>
                            <Col md="12" className="mt-2">
                              <SocialIcons
                                contact={JSON.parse(profile?.contact?.social)}
                              />
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </>
                )}
              </>

              <>
                <div className="about mb-4 border-top pt-4 mt-4">
                  <h3 className="title mb-3">About</h3>
                  <p
                    className="about-text"
                    dangerouslySetInnerHTML={renderElement(
                      profile?.candidate?.cover_letter ||
                        profile?.profile?.about ||
                        profile?.about
                    )}
                  ></p>
                </div>
                {profile?.edu?.length > 0 && (
                  <div className="education mb-4 pt-4 border-top">
                    <h3 className="title mb-3">Education</h3>
                    <ul className="timeline">
                      {profile.edu.length > 0 ? (
                        profile.edu.map((education, index) => {
                          return (
                            <li key={index}>
                              <TimelineInfo data={education} />
                            </li>
                          )
                        })
                      ) : (
                        <p>No Education data</p>
                      )}
                    </ul>
                  </div>
                )}
                {profile?.exp && profile?.exp?.length > 0 && (
                  <div className="work mb-4 pt-4 border-top">
                    <h3 className="title mb-3">Work & Experience</h3>
                    <ul className="timeline">
                      {profile.exp && profile.exp.length > 0 ? (
                        profile.exp.map((experience, index) => (
                          <li key={index}>
                            <TimelineExperienceInfo data={experience} />
                          </li>
                        ))
                      ) : (
                        <p>No Experience Data Available</p>
                      )}
                    </ul>
                  </div>
                )}
                {profile?.portfolio && profile?.portfolio?.length > 0 && (
                  <div className="portfolio mb-4 pt-4 border-top">
                    <h3 className="title mb-3">Portfolio</h3>
                    <Row>
                      {profile.portfolio && profile.portfolio.length > 0 ? (
                        profile.portfolio.map((portfolio, index) => {
                          return (
                            <Col sm="6">
                              {/* eslint-disable-next-line */}
                              <a onClick={() => showPortfolio(true, portfolio)}>
                                <PictureCaption key={index} data={portfolio} />
                              </a>
                            </Col>
                          )
                        })
                      ) : (
                        <Col sm="6" lg="4">
                          <p>No portfolio yet.</p>
                        </Col>
                      )}
                      <ModalComponent
                        show={show}
                        onHide={() => handlePortfolioClose}
                        setShow={handlePortfolioClose}
                      >
                        <div>
                          <img
                            width="100%"
                            alt=""
                            src={selectedPortfolio.image}
                          ></img>
                          <div>
                            <h5 className="mt-4 topic">Project Title:</h5>
                          </div>
                          <div className="mb-4 port-title">
                            <p>
                              <strong>{selectedPortfolio.title}</strong>
                            </p>
                          </div>
                          <div>
                            <h5 className="topic">Project URL:</h5>
                          </div>
                          <div className="mb-4 project_url">
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={selectedPortfolio.project_url}
                            >
                              <strong>{selectedPortfolio.project_url}</strong>
                            </a>
                          </div>
                          <div>
                            <h5 className="topic">Project Description:</h5>
                          </div>
                          <div className="cert-desc">
                            <p>{selectedPortfolio.description}</p>
                          </div>
                        </div>
                      </ModalComponent>
                    </Row>
                  </div>
                )}
                {profile?.certificates && profile?.certificates?.length > 0 && (
                  <div className="portfolio mb-4 pt-4 border-top">
                    <h3 className="title mb-3">Training/Certificates</h3>
                    <Row>
                      {profile.certificates &&
                      profile.certificates.length > 0 ? (
                        profile.certificates.map((certificate, index) => {
                          return (
                            <Col sm="6">
                              {/* eslint-disable-next-line */}
                              <a
                                onClick={() => showTraining(true, certificate)}
                              >
                                <PictureCaption
                                  key={index}
                                  data={certificate}
                                />
                              </a>
                            </Col>
                          )
                        })
                      ) : (
                        <Col sm="6" lg="4">
                          <p>No certificates available yet.</p>
                        </Col>
                      )}
                    </Row>
                    <ModalComponent
                      show={show_train}
                      onHide={() => handleTrainingClose}
                      setShow={handleTrainingClose}
                    >
                      <div>
                        <img
                          width="100%"
                          alt=""
                          src={selectedCertificate.image}
                        ></img>
                        <div>
                          <h5 className="mt-4 topic">Training Title:</h5>
                        </div>
                        <div className="pl-0 port-title">
                          <p>
                            <strong>{selectedCertificate.title}</strong>
                          </p>
                        </div>
                        {/* <div>
                        <h5 className="topic">Certificate URL:</h5>
                      </div>
                      <div className="mb-4 project_url">
                        <a href={selectedCertificate.url}>
                          <strong>{selectedCertificate.url}</strong>
                        </a>
                      </div> */}
                        <div>
                          <h5 className="topic">Training Description:</h5>
                        </div>
                        <div className="cert-desc">
                          <p>{selectedCertificate.description}</p>
                        </div>
                      </div>
                    </ModalComponent>
                  </div>
                )}
                {profile?.candidate?.id && (
                  <div className="shortlisted pt-4 mb-4 border-top">
                    <p className="title mb-3">Shortlisted By(In the past)</p>
                    <p>
                      {!!profile?.candidate?.shortlist_count
                        ? profile.candidate.shortlist_count
                        : 0}
                      {profile.candidate.shortlist_count > 1
                        ? " Companies, have "
                        : " Company, has "}
                      shortlisted this candidate in the past.
                    </p>
                  </div>
                )}
                {profile?.candidate?.id && (
                  <div className="shortlisted pt-4 mb-4 border-top">
                    <p className="title mb-3">Viewed By(In the past)</p>
                    <p>
                      This Candidate's profile has been visited{" "}
                      <strong>{profile?.candidate?.views_count} times</strong>
                    </p>
                  </div>
                )}
              </>
            </Col>

            <Col lg="4 order-1 "></Col>
          </Row>
        </div>
      </Col>
    </>
  )
}

export default InfoSection
